import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Dropdown from '../../../Dropdown';
import { checkIsLoggedIn } from '../../../../store/slices/user';
import { getWallet, getWalletSummaryRequest } from '../../../../store/slices/wallet';
import formatWalletAmount from '../../../../helpers/formatWalletAmount';

const rowClasses = 'flex items-baseline justify-between gap-6 py-1 text-sm whitespace-nowrap';
const amountClasses = 'tabular-nums';

const WalletBalance = () => {
  const dispatch = useDispatch();
  const isLoggedIn = useSelector(checkIsLoggedIn);
  const isTravelAgencyLoaded = useSelector((store) => !!store.user.travelAgency);
  const { hasWallet, hasLoaded, balance, creditLimit, available, currency, isFrozen, error } =
    useSelector(getWallet);

  useEffect(() => {
    if (isLoggedIn && isTravelAgencyLoaded && !hasLoaded) {
      dispatch(getWalletSummaryRequest());
    }
  }, [isLoggedIn, isTravelAgencyLoaded, hasLoaded, dispatch]);

  if (!isLoggedIn || !hasLoaded || !hasWallet) {
    return <></>;
  }

  if (error) {
    return (
      <span className="inline-block align-middle text-sm md:text-lg self-center text-red-600">
        Wallet: unavailable
      </span>
    );
  }

  const isUsingCredit = Number(balance) < 0;
  const doShowCredit = Number(creditLimit) > 0;

  return (
    <Dropdown className="cursor-pointer self-center">
      <Dropdown.Toggle>
        <span className="inline-block align-middle text-sm md:text-lg self-center">
          <span>Wallet: {formatWalletAmount(available, currency)}</span>
        </span>
        <Dropdown.Toggle.Chevron />
      </Dropdown.Toggle>
      <Dropdown.Menu widthClass="w-64">
        <Dropdown.Item withGridLayout={false}>
          <div className="text-gray-700">
            <div className={`${rowClasses} font-semibold text-gray-900`}>
              <span>Available to spend</span>
              <span className="tabular-nums">{formatWalletAmount(available, currency)}</span>
            </div>
            <div className="border-t border-gray-200 my-2" />
            <div className={rowClasses}>
              <span>{isUsingCredit ? 'Credit used' : 'Wallet balance'}</span>
              <span className={amountClasses}>{formatWalletAmount(balance, currency)}</span>
            </div>
            {doShowCredit && (
              <div className={rowClasses}>
                <span>Credit limit</span>
                <span className={amountClasses}>{formatWalletAmount(creditLimit, currency)}</span>
              </div>
            )}
            <div className={rowClasses}>
              <span>Status</span>
              <span className={isFrozen ? 'text-red-600 font-semibold' : amountClasses}>
                {isFrozen ? 'Frozen' : 'Active'}
              </span>
            </div>
          </div>
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default WalletBalance;
